import * as React from "react"
import { ChakraProvider } from "@chakra-ui/react"
import theme from "./theme/theme"
import "./src/styles/global.css"

export const wrapRootElement = ({ element }) => (
  <ChakraProvider theme={theme}>{element}</ChakraProvider>
)
